import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bddc40e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "toolbar__option-wrapper"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "option__icon" }
const _hoisted_4 = { class: "option__label" }
const _hoisted_5 = {
  key: 0,
  class: "toolbar__option-margin"
}
const _hoisted_6 = {
  key: 1,
  class: "toolbar__option-edit-margin"
}
const _hoisted_7 = {
  key: 2,
  class: "toolbar__edit-btn-wrapper"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-btn__text" }, "完成", -1))


const __default__ = {
  name: 'ContentToolBar'
}

import { ref, watch, onMounted, onBeforeUnmount, computed } from 'vue'
import Icon from '@teams/common/components/icon'
import contentToolbarProps, {
  optionsKeysMap,
  OptionType,
  OptionsKeysType
} from './props'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: contentToolbarProps,
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "86c5ab6a": (props.top),
  "51f7545e": (props.left),
  "09dcc592": (props.right),
  "16c90575": (props.bottom),
  "b88b44ba": (_unref(multipleStyle).optionPadding)
}))



const editBtnClickHandler = async () => {
  await props.onEditBtnClick?.()
}

const commonOptionHandler = async (option: OptionType, idx: number) => {
  const res = await props.onOptionClick?.(
    option.key,
    option,
    getToggleListItem(idx)
  )
  if (res === undefined) {
    toggleListItem(idx)
  }
}
const allOptions = ref<{
  [key in OptionsKeysType]: OptionType
}>({
  edit: {
    key: optionsKeysMap.edit,
    iconName: 'contentToolbarEdit',
    label: '编辑',
    handler: commonOptionHandler
  },
  directory: {
    key: optionsKeysMap.directory,
    iconName: 'contentToolbarDirectory',
    label: '目录',
    handler: commonOptionHandler
  },
  annotation: {
    key: optionsKeysMap.annotation,
    iconName: 'contentToolbarAnnotation',
    label: '批注',
    handler: commonOptionHandler
  },
  docCtl: {
    key: optionsKeysMap.docCtl,
    iconName: 'contentToolbarDocCtl',
    label: '文档',
    handler: commonOptionHandler
  },
  play: {
    key: optionsKeysMap.play,
    iconName: 'contentToolbarPlay',
    label: '放映',
    handler: commonOptionHandler
  },
  review: {
    key: optionsKeysMap.review,
    iconName: 'contentToolbarReview',
    label: '评论',
    handler: commonOptionHandler
  }
})
const toggleListItem = (idx: number) => {
  optionsList.value[idx].active = !optionsList.value[idx].active
}
const getToggleListItem = (idx: number) => () => toggleListItem(idx)

const optionsList = ref<Array<OptionType>>([])

const multipleStyle = computed(() => ({
  optionPadding: optionsList.value.length === 1 ? '7px 6px' : '12px 6px'
}))

watch(
  () => props.optionsOrder,
  val => {
    if (val) {
      optionsList.value = val.map(key => allOptions.value[key])
    }
  },
  { immediate: true }
)

const onSetListItemActive = (key: string, val: boolean) => {
  const target = optionsList.value.find(item => item.key === key)
  if (target) {
    target.active = val
  }
}

onMounted(() => {
  props.evtBus?.on((eventName, payload) => {
    if (eventName === 'setListItemActive') {
      const _payload = payload as { key: string; val: boolean } | undefined
      const key = _payload?.key || ''
      const val = _payload?.val || false
      onSetListItemActive(key, val)
    }
  })
})
onBeforeUnmount(() => {
  props.evtBus?.reset()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "toolbar-container",
    style: _normalizeStyle(props.containerStyle)
  }, [
    (props.showToolbarBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionsList.value, (option, idx) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: option.key
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(['toolbar__option-container', { 'is-active': option.active }]),
                onClick: ($event: any) => (option.handler(option, idx))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(Icon), {
                    size: 24,
                    name: option.iconName
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(option.label), 1)
              ], 10, _hoisted_2),
              (idx !== optionsList.value.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (props.showEditBtn && props.showToolbarBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
      : _createCommentVNode("", true),
    (props.showEditBtn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "toolbar__edit-btn-container",
            onClick: editBtnClickHandler
          }, [
            _createElementVNode("div", null, [
              _createVNode(_unref(Icon), {
                size: 24,
                name: "contentToolbarEditBtn",
                fill: "transparent"
              })
            ]),
            _hoisted_8
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})